import 'css-chunk:src/app/containers/Home/ClientsView/ClientsView.scss';export default {
  "ClientsView": "_ClientsView_1or6o_1"
};